export default "__VITE_ASSET__XemZuyl$__"